const ImportPermissions = {
  edit: 'import:edit',
  create: 'import:create',
  delete: 'import:delete',
  view: 'import:view',
}

export default ImportPermissions
